import * as Style from './styles'

export default function QuestionMarkButton() {
  return <Style.QuestionMarkButtonContainer>?</Style.QuestionMarkButtonContainer>
}
